import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { ViolationListItem } from '../Common/ViolationListItem';
type Props = {
  violationsHistory: {} 
  violationDateKeys: string[]
  viewSelectedViolation: (event:any,i:any) => void,
    selectedItemId: string
};

const Data = (
  {
    violationsHistory,
    violationDateKeys,
    viewSelectedViolation,
      selectedItemId
  }: Props) => (
    <div>
    {violationDateKeys.map(( row ) => 
         <div className="ViolationhistoryDetails">
         <Scrollbars id="reactSilder"
           style={{ height: 600 }}
            renderTrackHorizontal={() => (
              <div id="Reactsilder" style={{ display: 'none', marginBottom: '0px'}} />
               )}
              >
             <div className="DetailListViolation">
             <p className = "historyHeaderFilter">P{window.localStorage["pageNo"]}: {row} - {violationsHistory[row].length} events</p>
              {violationsHistory[row].map(( item: any ) =>
                  (item.id === selectedItemId) ?
                      <ViolationListItem
                          key={item.id}
                          id={item.id}
                          handleChange={viewSelectedViolation}
                          ViolationType={item.violationType}
                          violationImage={item.violationImage}
                          vehicleSummary={item.vehicleSummary}
                          violationDate={item.violationDate}
                          imageSource={item.violationDetail.imageUrl}
                          backgroundColor={'#f6f6f6'}
                          borderLeft={'5px solid #f79647'}
                          listType={'history'}
                      />
                      :
                      <ViolationListItem
                          key={item.id}
                          id={item.id}
                          handleChange={viewSelectedViolation}
                          ViolationType={item.violationType}
                          vehicleSummary={item.vehicleSummary}
                          violationImage={item.violationImage}
                          violationDate={item.violationDate}
                          imageSource={item.violationDetail.imageUrl}
                          backgroundColor={'#FFFFFF'}
                          borderLeft={'5px solid #ffffff'}
                          listType={'history'}
                      />
                )}
             </div> 
        </Scrollbars>
        </div>
      )}
      
  </div>
);

export default Data;


// WEBPACK FOOTER //
// ./src/components/ViolationsHistoryList/Data.tsx